import { render, staticRenderFns } from "./SetupAccountUsers.vue?vue&type=template&id=0bc4e47c&scoped=true"
import script from "./SetupAccountUsers.vue?vue&type=script&lang=js"
export * from "./SetupAccountUsers.vue?vue&type=script&lang=js"
import style0 from "./SetupAccountUsers.vue?vue&type=style&index=0&id=0bc4e47c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4e47c",
  null
  
)

export default component.exports